<template>
	<div
		class="tile"
		draggable="true"
		@dragstart="$emit('drag-start', $event)"
		@dragover="$emit('drag-over', $event)"
		@drop="$emit('drag-finish', $event)"
		@dragend="$emit('drag-end', $event)"
	>
		<!-- caption -->
		<div class="tile-container">
			<div class="tile-header">Grid</div>
			<div class="buttons">
				<div class="button" title="Close Tile" @click="$emit('remove-tile')">
					<svg width="24" height="24" viewBox="0 0 24 24">
						<path
							d="M12.71,12l4.64-4.65a.49.49,0,1,0-.7-.7L12,11.29,7.35,6.65a.49.49,0,0,0-.7.7L11.29,12,6.65,16.65a.48.48,0,0,0,0,.7.48.48,0,0,0,.7,0L12,12.71l4.65,4.64a.48.48,0,0,0,.7,0,.48.48,0,0,0,0-.7Z"
						/>
					</svg>
				</div>
			</div>
		</div>
		<!-- content -->
		<div class="tile-content">
			<wj-flex-grid
				:isReadOnly="true"
				:headersVisibility="'Column'"
				:selectionMode="'ListBox'"
				:itemsSource="data"
			>
				<wj-flex-grid-column :binding="'id'" :header="'ID'" :width="40"></wj-flex-grid-column>
				<wj-flex-grid-column :binding="'date'" :header="'Date'" :width="'*'" :format="'MMM yyyy'"></wj-flex-grid-column>
				<wj-flex-grid-column :binding="'sales'" :header="'Sales'" :format="'c'"></wj-flex-grid-column>
				<wj-flex-grid-column :binding="'expenses'" :header="'Expenses'" :format="'c'"></wj-flex-grid-column>
				<wj-flex-grid-column :binding="'profit'" :header="'Profit'" :format="'c'"></wj-flex-grid-column>
			</wj-flex-grid>
		</div>
	</div>
</template>

<script>
import '@mescius/wijmo.vue2.grid';

import DataService from '../services/data.service';

export default {
	name: 'Grid',
	data: () => ({ data: DataService.getData() }),
};
</script>